import { useEffect, useState } from "react";
import { replaceUrl } from "@/lib/replaceUrl";
import type { ProductKind } from "./stockHealth";

// URL value per kind, in the order the URL lists them.
const PARAM: Record<ProductKind, string> = {
  for_sale: "for-sale",
  gift: "gifts",
  not_moving: "not-moving",
};
const KINDS = Object.keys(PARAM) as ProductKind[];

function kindsFromUrl(): Set<ProductKind> {
  if (typeof window === "undefined") return new Set();
  const values = (new URLSearchParams(window.location.search).get("tab") ?? "").split(",");
  return new Set(KINDS.filter((kind) => values.includes(PARAM[kind])));
}

// Mirrors useState for the Inventory Overview "Show" filter, keeping it in the
// URL (?tab=gifts, ?tab=for-sale,not-moving) so a copied link or a bookmark
// opens the same products. The name "tab" is kept from when these were tabs,
// so older links still open Gifts or Not moving. Replaces the history entry,
// so Back leaves the page. Empty, missing or unknown means every product.
export function useProductKindsParam(): [Set<ProductKind>, (next: Set<ProductKind>) => void] {
  const [kinds, setKinds] = useState<Set<ProductKind>>(kindsFromUrl);

  useEffect(() => {
    const url = new URL(window.location.href);
    const param = KINDS.filter((kind) => kinds.has(kind)).map((kind) => PARAM[kind]).join(",");
    if (param) {
      url.searchParams.set("tab", param);
    } else {
      url.searchParams.delete("tab");
    }
    replaceUrl(url);
  }, [kinds]);

  return [kinds, setKinds];
}
